import React from "react";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";

import SortableListRow from "app/components/SortableList/SortableListRow";

const HeliReportRow = ({ classes, ...props }) => (
  <SortableListRow
    noborder
    striped={false}
    classes={{ root: classes.root }}
    {...props}
  />
);

const styles = theme => ({
  root: {
    "@media print": {
      height: "auto",
      minHeight: theme.altus.row.height,
    },
  },
});

export default compose(withStyles(styles))(HeliReportRow);
